/* @flow */
/* eslint-disable */
import React from 'react';
import styled from 'styled-components';

import withI18n from '../../../utils/withI18n';
import { getLabel } from '../../../utils/i18n';
import FlexBox from '../../FlexBox';

const WrapperBox = styled(FlexBox)`
  width: 100%;
  height: auto;
  overflow: hidden;
  background: #0f1217;
`;

const Content = styled.div`
  width: 100%;
  margin: 0 auto;
  text-align: center;
  font-family: ${({ theme }) => theme.fontIBMLight};
  vertical-align: middle;
  &.black {
    background: #0b0e11;
  }
`;

const Box = styled(FlexBox)`
  max-width: 1260px;
  height: 100vh;
  margin: ${({ margin }) => margin || 0};
  color: #fff;
  font-family: ${({ theme }) => theme.fontIBMLight};
  text-align: left;
  align-content: center;
  h3 {
    font-size: 54px;
    font-weight: 300;
    line-height: 70px;
    padding: 0 0 26px 0;
    margin: 0;
    font-family: ${({ theme }) => theme.fontIBMLight};
  }
  p {
    padding: 0;
    margin: 0 0 30px 0;
    font-size: 20px;
    line-height: 28px;
    font-family: ${({ theme }) => theme.fontIBMRegular};
    color: rgba(255, 255, 255, 0.6);
  }
  a {
    font-size: 18px;
    font-weight: 500;
    color: rgba(240, 185, 11, 1);
    line-height: 32px;
    text-decoration: none;
    font-family: ${({ theme }) => theme.fontIBMMedium};
  }
`;
const LeftBox = styled(FlexBox)`
  width: 580px;
  img {
    opacity: 0.6;
    height: 400px;
  }
`;
const RightBox = styled(FlexBox)`
  padding-left: 116px;
  width: 680px;
  img {
    opacity: 0.6;
    height: 400px;
  }
`;

const BuildRightBox = styled.div`
  padding-left: 116px;
  width: 680px;
  img {
    opacity: 0.6;
    height: 400px;
  }
`;

type Props = {
  i18n: Object,
  locale: string,
};

export default
@withI18n
class FreedomAndBuild extends React.Component<Props> {
  static defaultProps = {
    i18n: {},
    locale: 'en',
  };

  render() {
    const { i18n } = this.props;
    return (
      <WrapperBox direction="column">
        <Content>
          <Box direction="row" align="center" margin="0 auto">
            <LeftBox>
              <h3>{getLabel('exchange-freedomBuild-globalFreedom', i18n)}</h3>
              <p>{getLabel('exchange-freedomBuild-visionCurrencyFreedom', i18n)}</p>
              <a rel="noopener noreferrer nofollow" id="freedomBuild-a-vision">
                {getLabel('exchange-freedomBuild-vision', i18n)}
              </a>
            </LeftBox>
            <RightBox justify="flex-end">
              <img src={require('./imgs/freedom.svg')} alt="Global Freedom" />
            </RightBox>
          </Box>
        </Content>
        <Content className="black">
          <Box direction="row" align="center" margin="0 auto">
            <LeftBox>
              <img src={require('./imgs/build.svg')} alt="Building Infrastructure" />
            </LeftBox>
            <BuildRightBox>
              <h3>{getLabel('exchange-freedomBuild-buildingInfrastructure', i18n)}</h3>
              <p>{getLabel('exchange-freedomBuild-ourMissionIs', i18n)}</p>
              <br/>
              <div>
                <a rel="noopener noreferrer nofollow"  id="freedomBuild-a-mission">
                  {getLabel('exchange-freedomBuild-mission', i18n)}
                </a>
              </div>
            </BuildRightBox>
          </Box>
        </Content>
      </WrapperBox>
    );
  }
}
